<template>
  <div class="parking_box">
    <template v-if="showPage">
      <!-- 停车场信息 -->
      <parking-message
        :parkingMess="parkingMess"
        :parkList="parkList"
        :applyData="applyData"
        @parkSelect="parkSelect"
      ></parking-message>
      <!-- 用户申请后状态 -->
      <apply-status
        v-if="applyMess"
        :applyData="applyData"
        @delectContract="delectContract"
        @repeatApply="repeatApplySubmit"
      ></apply-status>
      <template v-if="!applyMess && prkParkFeeBeanList.length > 0">
        <!-- 套餐类型 -->
        <package-select
          :parkingMess="parkingMess"
          @packageChange="packageChange"
          :dayNightType="dayNightType"
          :ParkFeeId="ParkFeeId"
          :ParkFeeSelectItem="ParkFeeSelectItem"
        ></package-select>
        <!-- 填写申请信息 -->
        <apply-message
          :key="parkingMess.id"
          @inputChange="inputChange"
          :parkingMess="parkingMess"
          :maxEndDay="maxEndDay"
        ></apply-message>
        <!-- 车牌号 -->
        <card-number
          :key="parkingMess.id+'card'"
          :parkingMess="parkingMess"
          @inputChange="inputChange"
          :mustImg="mustImg"
          @delectCardItem="delectCardItem"
        ></card-number>
      </template>
      <!-- 候补tips -->
      <template
        v-if="!showXuqianTips && parkingMess.overplusPMonthlyNumber<=0 && hb_tips && !applyData.prkParkApplyLogBeans"
      >
        <section class="hb_height"></section>
        <section class="hb_tips">
          <img class="hint_icon" src="../../assets/images/parking/icon_hint.png" />
          <p>已无车位名额，排队成为候补申请车位</p>
          <img
            class="close_icon"
            @click="hb_tips = false"
            src="../../assets/images/parking/close.png"
          />
        </section>
      </template>
      <!-- 没有缴费tips -->
      <template
        v-if="!showXuqianTips && applyMess && applyData.applyStatus == 2 && !applyData.prkParkMonthlyBillBeans && nopay_tips && !(applyData.prkParkApplyLogBeans.length == 1 && applyData.prkParkApplyLogBeans[0].applyStatus == 3)"
      >
        <section class="hb_height"></section>
        <section class="hb_tips">
          <img class="hint_icon" src="../../assets/images/parking/icon_hint.png" />
          <p>您当前还没有缴费，请点击下方缴费按钮，缴费成功后可享受月租优惠！</p>
          <img
            class="close_icon"
            @click="nopay_tips = false"
            src="../../assets/images/parking/close.png"
          />
        </section>
      </template>
      <!-- 续签 tips -->
      <template v-if="showXuqianTips && nopay_tips && !hasTwoContract">
        <section class="hb_height"></section>
        <section class="hb_tips">
          <img class="hint_icon" src="../../assets/images/parking/icon_hint.png" />
          <p>
            您的优惠资格距离失效还有
            <span>{{lastDays+1}}</span>天，请尽快操作续签，以免影响正常使用！
          </p>
          <img
            class="close_icon"
            @click="nopay_tips = false"
            src="../../assets/images/parking/close.png"
          />
        </section>
      </template>
      <section class="footer_h"></section>
      <!--   《停车月保申请须知内容》-->
      <div class="agreeView" v-if="isShowAgreeActon()">
          <div @click="changeAgree" v-if="!isAgree" class="agreeView_div"></div>
          <img  @click="changeAgree" v-else class="agreeView_icon" src="../../assets/images/icon_check_0.png" />
          <span @click="showPopup" class="agreeView_span1">请查阅并同意</span>
          <span @click="showPopup"  class="agreeView_span2">{{"《"+parkingMess.noticeTitle+"》"}}</span>
      </div>
      <!-- 不显示续签,有申请数据,不显示重新申请 -->
      <common-footer
        v-if="!showXuqianTips && !applyMess && !repeatApply"
        text="立即申请"
        :canClick="canClick"
        @btnClick="btnClick"
      ></common-footer>
      <common-footer
        v-if="!showXuqianTips && applyMess && applyData.applyStatus !=7 && !repeatApply && showQjf || hasTwoContract"
        text="去缴费"
        :canClick="true"
        @btnClick="toPay"
      ></common-footer>
      <common-footer
        v-if="!showXuqianTips && applyMess && repeatApply && applyData.applyStatus != 0"
        text="重新申请"
        :canClick="true"
        @btnClick="repeatApplyFun"
      ></common-footer>
      <section class="footer_box" v-if="showXuqianTips && !repeatApply && !hasTwoContract">
        <span class="footer_left_btn" @click="toPay">去缴费</span>
        <span class="footer_right_btn" @click="toXuqian">去续签</span>
      </section>
    </template>
    <mt-popup v-model="isshowPopup" class="mint-popup">
        <div class="popupview">
            <span class="popupview-span1">{{parkingMess.noticeTitle}}</span>
            <textarea readonly class="popupview-span2" v-model="parkingMess.noticeContent"></textarea>
            <!-- <span class="popupview-span2" v->dsdsd  \n  sdsdsd</span> -->
            <span @click="hidePopup" class="popupview-span3">知道了</span>
        </div>
    </mt-popup>
  </div>
</template>

<script>
import ParkingMessage from './components/parkingMessage';
import PackageSelect from './components/packageSelect';
import ApplyMessage from './components/applyMessage';
import ApplyStatus from './components/applyStatus';
import CardNumber from './components/cardNumber';
import CommonFooter from '../../components/footer';
import util from '../../utils/util';
import { approvalMixin } from '../../utils/approvalMixin';
import storage from '../../utils/storage';
import { loadParkHeaderById, spaceUpPcHttp } from '../../utils/api';
import { mapState } from 'vuex';
export default {
  name: 'parking',
  props: {},
  mixins: [approvalMixin],
  components: {
    ParkingMessage,
    PackageSelect,
    ApplyMessage,
    CardNumber,
    CommonFooter,
    ApplyStatus
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      isAgree :false,
      isShowAgree :false,
      isshowPopup:false,
      parkList: [],//车场列表
      approvalProcessTime: 0,//发起流程次数
      startInstanceTime: 0,//发起审批次数
      repeatApply: false,//是否显示重新申请按钮
      showXuqianTips: false,//是否显示续签提醒
      lastDays: 0,//距离失效还剩下多少天
      canClick: false,
      hb_tips: true,
      nopay_tips: true,
      applyMess: false,
      parkId: '',//停车场id
      applyData: {},
      parkingMess: {},
      prkParkFeeBeanList: [],
      mustImg: 2,//是否必传图片 1是，2否
      showPage: false,
      applyUser: '',
      applyStartDay: '',
      applyEndDay: '',
      userName: '',
      ParkFeeSelectItem: {},
      ParkFeeId: '',
      feeTypeId: '',
      feeTypeName: '',// 取值对应的是parkTypeName
      vipTypeCode: '',// 取值对应的是typeCode
      vipTypeName: '',// 取值对应的是typeName
      maxEndDay: '',//有价格区间的最大日期
      dayNightType: 1,// 1、全天；2、白天；3夜晚
      cardList: '',//车牌数据列表
      plateNo: '',//车牌号
      timemap: '',
      changeTargetIdUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/bindSomeAttachments',
      queryBpmFlowByBuildIds: spaceUpPcHttp + '/syscfg/bpmSyscfg/queryBpmFlowByBuildIds',
      hex_md5_return: '',
      showQjf: false,
      hasTwoContract: false//是否有2份合同都是生效状态
    }
  },
  created() {
    if (!this.common.userId) {
      this.$router.push({
        path: '/login',
        query: {
          Rurl: `/parking?marketId=${this.$route.query.marketId}&cityId=${this.$route.query.cityId}`
        }
      });
      return;
    }
    // monthType 1月租(年月),2是年月日
    this.getParkId()
  },
  activated() {
    if (storage.getS("isNeedFresh")) {
      storage.removeS('isNeedFresh')
      this.ParkFeeSelectItem = {};
      this.getParkId()
    }

    if (storage.getS("ParkFeeSelectItem")) {
      this.ParkFeeSelectItem = JSON.parse(storage.getS("ParkFeeSelectItem"));
      storage.removeS('ParkFeeSelectItem');
    }
  },
  methods: {
    showPopup(){
        this.isshowPopup=true;
    },
    hidePopup(){
        this.isshowPopup =false;
    },
    resetSign() {
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong + si + this.timemap + platfrom
      this.hex_md5_return = this.$md5(str)
    },
    repeatApplyFun() {
      // this.repeatApply = false
      // this.applyMess = false
      this.$router.push(`/repeatApply?parkId=${this.parkId}`)
    },
    // var ary = new Array("1111", "222", "33", "111", "22");
    // 验证重复元素，有重复返回true；否则返回false
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    delectCardItem(val) {
      let cardList = val.data || [];
      this.cardList = cardList;
      let plateNo = []
      cardList.forEach(item => {
        plateNo.push(item.cardNumber)
      })
      this.plateNo = plateNo.join(",")
    },
    inputChange(val) {
      if (val.type == 'name') {
        this.userName = val.val;
      } else if (val.type == 'time') {
        this.applyStartDay = val.val.startTime
        this.applyEndDay = val.val.endTime
      } else if (val.type == 'card') {
        let cardList = val.data || [];
        this.cardList = cardList;
        let plateNo = []
        cardList.forEach(item => {
          plateNo.push(item.cardNumber)
        })
        this.plateNo = plateNo.join(",")
      }
      if (!this.userName || !this.applyStartDay || !this.applyEndDay || !this.plateNo) {
        this.canClick = false
      } else {
        this.canClick = true
      }

      //
      if(this.isShowAgreeActon() && this.canClick){
          if(!this.isAgree){
            this.canClick = false
          }
      }
    },
    changeAgree(){
      this.isAgree =!this.isAgree;
      if (!this.userName || !this.applyStartDay || !this.applyEndDay || !this.plateNo ||!this.isAgree) {
        this.canClick = false
      } else {
        this.canClick = true
      }
    },
    packageChange(item) {
      if (item) {
        this.dayNightType = item.dayNightType
        this.maxEndDay = item.maxEndDay
        this.ParkFeeId = item.id;
        this.feeTypeName = item.parkTypeName;
        this.vipTypeCode = item.typeCode;
        this.vipTypeName = item.typeName;
      }
    },
    btnClick() {
      let plateNo = []
      this.cardList.forEach(item => {
        plateNo.push(item.cardNumber)
      })
      let isRepeat = this.isRepeat(plateNo)
      if (isRepeat) {
        util.showToast('车牌号重复！')
        return;
      }


      if(this.parkingMess.monthType == 2 && this.parkingMess.applyMaxUnit == 1){
         if (new Date(this.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime() - new Date(this.applyEndDay.replace(/-/g, "/") + ' 23:59:59').getTime() > 0) {
        util.showToast('结束时间应该大于开始时间', 2000)
        return false;
      }

      }else{   //月租模式 返回日期缺少天
       if (new Date(this.applyStartDay.replace(/-/g, "/") + '/1 00:00:00').getTime() - new Date(this.applyEndDay.replace(/-/g, "/") + '/1 23:59:59').getTime() > 0) {
        util.showToast('结束时间应该大于开始时间', 2000)
        return false;
      }
       var ns = this.applyStartDay.replace(/-/g, "/") + '/1 00:00:00';
       console.log(ns)
      // //  var ts = new Date(this.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime()
      // //  console.log(ts )
      //   var time = this.applyStartDay + ' 00:00:00';
      //   time = time.replace(/-/g,':').replace(' ',':');
      //   time = time.split(':');
      //   var stime = new Date(Number(time[0]) ,Number(time[1])-1,Number(time[2]),Number(time[3]),Number(time[4]),Number(time[5]));

      //   var time1 = this.applyEndDay + ' 23:59:59';
      //   time1 = time1.replace(/-/g,':').replace(' ',':');
      //   time1 = time1.split(':');
      //   var eTime = new Date(Number(time1[0]) ,Number(time1[1])-1,Number(time1[2]),Number(time1[3]),Number(time1[4]),Number(time1[5]));

        var stime = new Date(this.applyStartDay.replace(/-/g, "/") + '/1 00:00:00')
        var eTime = new Date(this.applyEndDay.replace(/-/g, "/") + '/1 23:59:59')
        // console.log("stime1====  " + JSON.stringify(stime1))
        // console.log("eTime1====  " + JSON.stringify(eTime1))
        // var stime = new Date(stime1)
        // var eTime = new Date(eTime1)
        console.log("stime====  " + JSON.stringify(stime))
        console.log("eTime====  " + JSON.stringify(eTime))
        var year1 = util.formatTime(stime, 17).year
        var month1 = util.formatTime(stime, 17).month
        var year2 = util.formatTime(eTime, 17).year
        var month2 = util.formatTime(eTime, 17).month
        var yc = year2 -year1
        var mc = month2- month1;
        var mc1 = yc*12 +mc
        console.log("yc===" +yc +' year1=== ' + year1 + " year2 ====  " + year2  +'  month1====  ' +month1 + ' month2===== ' + month2 +"mc ==" +mc1)
        if(mc1>=this.parkingMess.applyMaxCount){
          util.showToast('注意：结束日期距离设置的开始日期不能超过'+this.parkingMess.applyMaxCount+"个月哦", 2000)
          return false;
        }
        // console.log("2222222")
        // return false;

      }

      // 车牌对应的图片是否是必填
      if (this.mustImg == '1') {
        let status = true;
        this.cardList.forEach(item => {
          if (item.fileList.length == 0) {
            status = false;
          }
        })
        if (!status) {
          util.showToast("请上传车牌图片")
          return false;
        }
      }
      let applyMinUnit = this.parkingMess.applyMinUnit;//最小起租单位（1天 2月）
      // let applyMaxCount = this.parkingMess.applyMaxCount;//最大起租数
      let applyMinCount = this.parkingMess.applyMinCount;//最小起租数
      // let applyMaxUnit = this.parkingMess.applyMaxUnit;//最大申请单位（1天 2月）
      let monthType = this.parkingMess.monthType;//1(整月模式 年月),2(非整月 年月日)
      if (monthType == 1) {
        let startD = this.applyStartDay.split("-");
        let endD = this.applyEndDay.split("-");
        if ((endD[0] - startD[0]) * 12 + Number(endD[1]) - Number(startD[1]) < applyMinCount - 1) {
          util.showToast(`最小起租${applyMinCount}个月`, 2000)
          return;
        }
      } else {
        // 最小起租单位为天
        if (applyMinUnit == 1) {
          // 结束时间-开始时间 小于 最小起租数
          if (Math.round((new Date(this.applyEndDay.replace(/-/g, "/") + ' 23:59:59').getTime() - new Date(this.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime()) / (24 * 60 * 60 * 1000)) < applyMinCount) {
            util.showToast(`最小起租${applyMinCount}天`, 2000)
            return false;
          }
        } else {
          // 开始时间+n月后的时间-结束时间 大于 结束时间
          let startD = this.applyStartDay.split("-");
          let ys = parseInt((startD[1] - 0 + this.parkingMess.applyMinCount) / 12);
          let year = startD[0] + ys;
          let month = startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12 >= 10 ? startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12 : '0' + (startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12)
          let day = Number(startD[2]) >= 10 ? startD[2] : '0' + startD[2]
          let newSjc = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() - 24 * 60 * 60 * 1000
          if (newSjc > new Date(this.applyEndDay.replace(/-/g, ".") + ' 23:59:59').getTime()) {
            util.showToast(`最小起租${applyMinCount}月`, 2000)
            return false;
          }
        }
      }
      if (this.applyStartDay.split('-').length === 2) {
        this.applyStartDay = this.applyStartDay + "-01"
        let endt = new Date(this.applyEndDay.split('-')[0], this.applyEndDay.split('-')[1], 0);
        let { year, month, day } = util.formatTime(endt, 17);
        this.applyEndDay = util.formatTime(new Date(year + '/' + month + '/' + day + ' 23:59:59'), 9)
      }
      util.showLoading('提交中...')
      this.canClick = false
      let params = {
        "platform": "RST",
        "userId": this.common.userId,
        "userName": this.userName,
        "companyName": "",
        "companyId": "",
        "subProjectId": this.common.marketInfo.id,//项目id
        "phone": this.common.userInfo.account || this.common.userInfo.phone,
        "numberType": 2,//申请类型 2个人月租 3临停优惠
        "parkHeaderId": this.parkingMess.id,//车场id
        "plateNo": this.plateNo,//车牌
        "applyStartDay": this.applyStartDay.replace(/-/g, ".") + ' 00:00:00',
        "applyEndDay": this.applyEndDay.replace(/-/g, ".") + ' 23:59:59',
        "dayNightType": this.dayNightType,// 1、全天；2、白天；3夜晚
        feeTypeId: this.ParkFeeId,
        feeTypeName: this.feeTypeName,
        vipTypeCode: this.vipTypeCode,
        vipTypeName: this.vipTypeName,
        "url": "/parking/rstParkLot/applayParkLot"
      }
      if (this.common.userTenantInfo.id) {
        params.companyName = this.common.userTenantInfo.company,
          params.companyId = this.common.userTenantInfo.companyId
      }
      loadParkHeaderById(params).then(res => {
        console.log(res)
        if (res.res.code === 10000 && res.body) {
          let prkParkLotPlateBeans = res.body.data.prkParkLotPlateBeans || [];
          // 遍历车牌列表 替换对应的图片
          prkParkLotPlateBeans.forEach(item => {
            this.cardList.forEach(card => {
              if (card.cardNumber == item.plateNo) {
                if (card.fileList.length > 0) {
                  this.changeTarget(card, item.id)
                }
              }
            })
          })
          // 如果剩余车位没有了,不发起审批
          console.log( 'approvalProcess  '  +  JSON.stringify(res.body.data))
          if (this.parkingMess.overplusPMonthlyNumber <= 0) {
            util.hideLoading()
            this.loadParkLot()
          } else {
            // 申请待办
            
            if(res.body.data.applyStatus ==1){
              console.log( 'in approvalProcess  action ')
               this.approvalProcess(res.body.data,
              () => {
                util.hideLoading()
                this.loadParkLot()
              }, () => {
                this.canClick = true
                util.hideLoading()
                util.showToast('提交失败')
              })
          
            }else{
              this.canClick = true
              util.hideLoading()
              this.loadParkLot()
            }
          }
        } else {
          this.canClick = true
          util.hideLoading()
          util.showToast(res.res.msg)
        }
      })
    },
    // 重新发起审批流程
    repeatApplySubmit() {
      util.showLoading('提交中...')
      this.approvalProcess(this.applyData,
        () => {
          util.hideLoading()
          this.loadParkLot()
        }, () => {
          this.canClick = true
          util.hideLoading()
          util.showToast('提交失败')
        })
    },
    changeTarget(item, id) {
      let self = this;
      this.resetSign()
      fetch(self.changeTargetIdUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": self.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'newTarget': id,
          'oldTarget': item.targetId,
          'bizCode': 'TCP',
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': self.common.marketInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log("替换成功")
        console.log(res)
      })
    },
    // 获取停车场id
    getParkId() {
      util.showLoading()
      let params = {
        subProjectId: this.common.marketInfo.id,
        url: "/parking/rstParkHeader/queryParkHeaderList"
      }
      loadParkHeaderById(params).then(res => {
        util.hideLoading()
        console.log(res)
        if (res.res && res.res.code === 10000 && res.body && res.body.data) {
          let mess = res.body.data || []
          if (mess.length === 0) {
            util.showToast('没有停车场信息')
            return;
          }
          if (storage.get("parkingMess" + this.common.marketInfo.id)) {
            var saveMess = JSON.parse(storage.get("parkingMess" + this.common.marketInfo.id));
            var hasSaveMsee =false;
            for (var i=0;i<mess.length;i++){
               if( mess[i].id ==saveMess.id){
                  this.parkingMess= mess[i];
                  hasSaveMsee = true;
               }
            }
            if(!hasSaveMsee){
                this.parkingMess=mess[0];
            }
            //this.parkingMess = JSON.parse(storage.get("parkingMess" + this.common.marketInfo.id))
            this.parkId = this.parkingMess.id;
            this.mustImg = this.parkingMess.mustImg
          } else {
            this.mustImg = mess[0].mustImg
            this.parkId = mess[0].id
            this.parkingMess = mess[0]
          }
          this.parkList = mess;
          var showAgree =this.parkingMess.enableMonthNotice;
          if(showAgree !=2){
              this.isShowAgree =true
          }else{
              this.isShowAgree =false;
          }
          storage.setS("mustImg", this.mustImg)
          this.loadParkHeaderById()// 获取停车场信息
          this.loadParkLot()//获取用户申请信息
        } else {
          util.showToast(res.res.msg)
        }
      })
    },
    // 切换停车场
    parkSelect(val) {
      this.parkList.forEach(item => {
        if (val === item.parkName) {
          this.parkingMess = item;
          this.canClick = false;
          this.showXuqianTips = false;
          this.applyMess = false;
          this.repeatApply = false;
          this.showQjf = false;
          this.hasTwoContract = false;
          this.mustImg = item.mustImg
          var showAgree =this.parkingMess.enableMonthNotice;
          if(showAgree !=2){
              this.isShowAgree =true
          }else{
              this.isShowAgree =false;
          }
          storage.setS("mustImg", this.mustImg)
          storage.set("parkingMess" + this.common.marketInfo.id, JSON.stringify(item))
          this.parkId = item.id
          this.loadParkHeaderById()// 获取停车场信息
          this.loadParkLot()//获取用户申请信息
        }
      })
    },
    // 删除合同
    delectContract(item) {
      util.showModal("", '确定要删除该数据吗?', true, "确定", () => {
        util.showLoading()
        let params = {
          parkLotId: item.parkLotId,
          id: item.id,
          url: "/parking/rstParkLot/delApplay"
        }
        loadParkHeaderById(params).then(res => {
          util.hideLoading()
          console.log(res)
          if (res.res && res.res.code === 10000) {
            this.repeatApply = false;
            // 获取停车场信息
            this.loadParkHeaderById()
            this.loadParkLot()//获取用户申请信息
          } else {
            util.showToast(res.res.msg)
          }
        })
      });
    },
    // 根据停车场id获取停车场信息
    loadParkHeaderById() {
      util.showLoading();
      let params = {
        id: this.parkId,
        url: "/parking/rstParkHeader/loadParkHeaderById"
      }
      loadParkHeaderById(params).then(res => {
        util.hideLoading()
        console.log(res)
        if (res.res && res.res.code === 10000 && res.body) {
          this.parkingMess = res.body.data
          if (res.body.data.prkParkFeeBeanList && res.body.data.prkParkFeeBeanList.length > 0) {
            let newL = res.body.data.prkParkFeeBeanList.filter(item => { return item.parkType == 4 })
            this.prkParkFeeBeanList = newL;
            this.dayNightType = newL[0].dayNightType;//设置默认选中套餐
            this.ParkFeeId = newL[0].id;
            this.feeTypeName = newL[0].parkTypeName;
            this.vipTypeCode = newL[0].typeCode;
            this.vipTypeName = newL[0].typeName;
            this.maxEndDay = newL[0].maxEndDay;//价格区间最大日期
            if (newL.length == 0) {
              util.showModal('', '该项目停车场尚未配置停车月租优惠', false, '我知道了', () => {
                this.$router.go(-1)
              })
            }
          }
        } else {
          util.showToast(res.res.msg)
        }
      })
    },
    isShowAgreeActon(){
      if(!this.showXuqianTips && !this.applyMess && !this.repeatApply){
         if(this.isShowAgree){
           return true;
         }

      }
      return false;
    },
    // 获取用户申请信息
    loadParkLot() {
      util.showLoading()
      let params = {
        userId: this.common.userId,
        phone: this.common.userInfo.account || this.common.userInfo.phone,
        parkHeaderId: this.parkId,
        url: "/parking/rstParkLot/loadParkLot"
      }

      loadParkHeaderById(params).then(res => {
        console.log(res)
        if (res.res && res.res.code === 10000 && res.body && res.body.data) {
          // this.parkingMess = res.body.data
          this.applyMess = true;
          this.applyData = res.body.data;
          let contractDate = this.applyData.prkParkApplyLogBeans || [];
          if (contractDate.length > 0) {
            let status2Num = 0;//成功的合同数量
            let status4Num = 0;//失败的合同数量
            let status1Num = 0;//审批中的合同数量
            contractDate.forEach(item => {
              if (item.applyStatus == '2') {
                status2Num += 1;
              } else if (item.applyStatus == '1') {
                status1Num += 1;
              } else if (item.applyStatus == '4') {
                status4Num += 1;
              }
            })
            // 如果生效的合同一个都没有
            if (status2Num == 0) {
              // 审批中的有一个
              if (status1Num == 0) {
                this.repeatApply = true
              } else {
                this.repeatApply = false
              }
            } else if (status2Num == 1) {//一个合同生效
              this.showQjf = true;
              contractDate.forEach(item => {
                if (item.applyStatus == '2') {
                  this.dayNightType = item.dayNightType;
                  this.ParkFeeId = item.id;
                  this.feeTypeId = item.feeTypeId;
                  this.feeTypeName = item.parkTypeName;
                  this.vipTypeCode = item.typeCode;
                  this.vipTypeName = item.typeName;
                  // 判断该数据的结束时间是否小于当前的30天
                  let d = Math.floor((new Date(item.applyEndDay.replace(/\./g, '/')).getTime() - new Date().getTime()) / (24 * 60 * 60 * 1000));
                  if (status1Num == 1) {
                    this.showXuqianTips = false;
                  } else {
                    if (d < 30 && d >= -1) {
                      this.showXuqianTips = true;
                      this.showQjf = false;
                      this.nopay_tips = true;
                      this.lastDays = d
                    } else {
                      this.showXuqianTips = false;
                    }
                  }
                }
              })
            } else if (status2Num == 2) {
              this.hasTwoContract = true
            }

          } else {
            this.applyMess = false;
            this.repeatApply = false;
          }
        } else {
          this.applyMess = false;
          this.repeatApply = false;
          this.showXuqianTips = false
        }
        util.hideLoading()
        this.showPage = true;
      })
    },
    toPay() {
      if (this.applyData.prkParkApplyLogBeans.length >= 2 && this.hasTwoContract) {
        this.$router.push(`/parkingPay?id=${this.applyData.id}&parkHeaderId=${this.parkId}&xqContractId=${this.applyData.prkParkApplyLogBeans[0].id}`)
      } else {
        this.$router.push(`/parkingPay?id=${this.applyData.id}&parkHeaderId=${this.parkId}`)
      }
    },
    toXuqian() {
      // dayNightType : 续签 获取默认的 价格区间的最大日期
      this.$router.push(`/xuqian?parkId=${this.parkId}&dayNightType=${this.dayNightType}&ParkFeeId=${this.ParkFeeId}&feeTypeId=${this.feeTypeId}&approval=${this.parkingMess.enableRenewalApproval}`)
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.parking_box {
  background: #eee;
}
.footer_h {
  height: 208px;
}
.hb_height {
  height: 120px;
}
.hb_tips {
  position: fixed;
  bottom: 108px;
  left: 0;
  right: 0;
  .flex();
  padding: 14px 10px 14px 28px;
  justify-content: space-between;
  .borderT(#F4E2D2);
  background: #feeedf;
  .hint_icon {
    width: 28px;
    height: 28px;
    margin-right: 14px;
  }
  p {
    flex: 1;
    font-size: 26px;
    line-height: 36px;
    color: #8e7f71;
    span {
      color: #fd9838;
    }
  }
  .close_icon {
    padding-left: 20px;
    width: 44px;
    height: 44px;
  }
}
.footer_box {
  z-index: 334;
  height: 108px;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 18px;
  .flex();
  align-items: center;
  justify-content: space-between;
  span {
    margin: 0 10px;
    height: 68px;
    line-height: 68px;
    text-align: center;
    font-size: 28px;
    color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    display: block;
    flex: 1;
  }
  .footer_left_btn {
    background: #1740da;
  }
  .footer_right_btn {
    background: #16bc84;
  }
}

.agreeView{
  position: fixed;
  bottom:108px;left:0;right:0;
  // box-shadow:0px -1px 14px 0px rgba(0,0,0,0.09);
  z-index:333;
  background:#fff;
  height:88px;
  width:100%;
   display: flex;
  flex-direction: row;
  align-items: center;
}
.agreeView_div{
  //  display: flex;
   margin-left: 28px;
   width: 32px;
   height: 32px;
   border-radius: 100%;
   border: 2px solid #eaeaea;
   background-color: white;
}
.agreeView_icon{
   margin-left: 28px;
   width: 36px;
   height: 36px;
}
.agreeView_span1{
  margin-left: 14px;
  height:36px;
  font-size:26px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:36px;
}
.agreeView_span2{
  margin-left: 4px;
  height:36px;
  font-size:26px;
  font-weight:400;
  color:#1740DA;
  line-height:36px;
}
.popupview{
  width:600px;
  display: flex;
  flex-direction: column;
  background:rgba(255,255,255,1);
  border-radius:8px;
}
.popupview-span1{
  margin-left: 40px;
  margin-top: 40px;
  width: 520px;
  font-size:40px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:56px;
}
.popupview-span2{
  margin-left: 40px;
  margin-top: 28px;
  width: 520px;
  height: 450px;
  font-size:28px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;
}
.popupview-span3{
  margin-left: 40px;
  margin-top: 62px;
  margin-bottom: 40px;
  width:520px;
  height:88px;
  background:rgba(23,64,218,1);
  border-radius:4px;
  text-align: center;
  font-size:34px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:88px;
  background-color: #fff;

}

</style>
